import { memo, useState } from "react";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import TitledText, {
  TitledTextWithMargins,
} from "@coworker/apprestructured/src/task-management/components/TitledText/TitledText";
import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";
import Actions from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Actions/Actions";
import Highlight from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Highlight/Highlight";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";
import FixaCheckbox from "@coworker/apprestructured/src/shared/wrappers/FixaCheckbox/FixaCheckbox";

function TitledTextDemo() {
  const [title, setTitle] = useState("Title");
  const [text, setText] = useState("Some text");
  const [padding, setPadding] = useState(true);

  return (
    <Demo>
      <Name>TitledTextDemo</Name>
      <Highlight>
        {padding ? (
          <TitledTextWithMargins title={title} text={text} />
        ) : (
          <TitledText title={title} text={text} />
        )}
      </Highlight>
      <Actions>
        <FixaInputField
          label="title"
          type="text"
          id="titledtextdemo-title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <FixaInputField
          label="text"
          type="text"
          id="titledtextdemo-text"
          value={text}
          onChange={(e) => setText(e.target.value)}
        />
        <FixaCheckbox
          label="Padding"
          value="titledtextdemo-padding"
          id="titledtextdemo-padding"
          checked={padding}
          onChange={() => setPadding((prev) => !prev)}
        />
      </Actions>
    </Demo>
  );
}

export default memo(TitledTextDemo);
